import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CssBaseline from '@material-ui/core/CssBaseline';
import * as React from 'react';
import withStyles from '../../core/withStyles';
import withThemeSelector from '../../core/withThemeSelector';
import styles from './App.styles';
import AppContext from './AppContext';
export class App extends React.Component {
    constructor() {
        super(...arguments);
        this.modalRoot = typeof document !== 'undefined' ? document.createElement('div') : null;
        this.popoverRoot = typeof document !== 'undefined' ? document.createElement('div') : null;
        this.initRoots = (root) => {
            if (root && this.modalRoot && this.popoverRoot) {
                this.modalRoot.setAttribute('data-modal-root', '');
                this.popoverRoot.setAttribute('data-popover-root', '');
                root.appendChild(this.modalRoot);
                root.appendChild(this.popoverRoot);
            }
        };
    }
    render() {
        const { classes, children } = this.props;
        return (_jsx(AppContext.Provider, Object.assign({ value: { modalRoot: this.modalRoot, popoverRoot: this.popoverRoot } }, { children: _jsxs("div", Object.assign({ className: classes.root, ref: this.initRoots }, { children: [_jsx(CssBaseline, {}), children] })) })));
    }
}
export default withThemeSelector(withStyles(styles)(App));
//# sourceMappingURL=App.js.map